import {connect} from '@gisatcz/ptr-state';
import Presentation from './presentation';
import Select from '../../../../../state/Select';

const mapStateToProps = (state, ownProps) => {
	return {
		data: Select.unhab.charts.getTimeProgressData(
			state,
			ownProps.configuration,
		),
		multipleFeatures:
			Select.selections.getActive(state)?.data?.featureKeysFilter?.key?.length >
			1,
		currentDateRange: Select.unhab.getCurrentDateRange(state),
	};
};

const mapDispatchToProps = () => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Presentation);
